var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alien-table",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "table-header"
  }, [_c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("4")]), _vm._v(" "), _c('th', [_vm._v("5")]), _vm._v(" "), _c('th', [_vm._v("6")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-tbody"
  }, [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "r": ""
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("1")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a635db3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/alienTable.vue
// module id = 11
// module chunks = 0